import * as React from 'react'
import styled from 'styled-components'

import { PageTitleWithTotal } from '~/components/page-title-with-total'

interface DesktopProps {
  title: string
  numOfHints: number
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${props => props.theme.spacing.comfortable}px;
  padding-bottom: ${props => props.theme.spacing.cozy}px;
  width: 100%;
`

function Desktop(props: DesktopProps) {
  const { title, numOfHints } = props

  return (
    <>
      <Container>
        <PageTitleWithTotal title={title} total={numOfHints} />
      </Container>
    </>
  )
}

export default Desktop
